import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import pluralize from 'pluralize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

export default function UnusedAccessLevelsTooltip({ dragIdentifier, unusedAccessLevels }) {
  if (unusedAccessLevels.length === 0) return null;

  const tooltip = (
    <Tooltip id={`unused-access-levels-${dragIdentifier}`}>
      Add documents with
      {unusedAccessLevels.map((accessLevel, index) => (
        <React.Fragment key={accessLevel}>
          {index > 0 && (
            <span>or</span>
          )}
          {' '}
          <span className="fw-semibold text-capitalize text-decoration-underline">{accessLevel}</span>
          {' '}
        </React.Fragment>
      ))}
      access level to have that access level appear in Final Progress
    </Tooltip>
  );

  return unusedAccessLevels.length > 0 && (
    <OverlayTrigger overlay={tooltip} placement="bottom">
      <div className="text-muted d-flex align-items-center gap-2">
        {unusedAccessLevels.length} unused access {pluralize('level', unusedAccessLevels.length, false)}
        <FontAwesomeIcon icon={faQuestionCircle}/>
      </div>
    </OverlayTrigger>
  );
}

UnusedAccessLevelsTooltip.propTypes = {
  dragIdentifier: PropTypes.string.isRequired,
  unusedAccessLevels: PropTypes.arrayOf(PropTypes.string)
};
